import { useEffect, useRef, VFC } from 'react'
import {
  Routes,
  Route,
  useParams,
  useNavigate,
  useSearchParams
} from 'react-router-dom'
import WorkflowmodelListContainer from 'workflowmodel/List/Container'
import { PrivateRoutes } from 'infrastructure/shared/components'
import { postWorkflow } from 'workflow/shared/api'
import { ErrorMessage } from 'infrastructure/shared/types'
import { PostWorkflowResponse } from 'workflow/shared/types'

const WorkflowmodelRoutes: VFC = () => {
  return (
    <Routes>
      <Route element={<PrivateRoutes />}>
        <Route path='list' element={<WorkflowmodelListContainer />} />
        <Route path='/new/:workflowModelUuid' element={<RedirectWorkflow />} />
      </Route>
    </Routes>
  )
}

function RedirectWorkflow(): JSX.Element {
  const isFetching = useRef(false)

  const { workflowModelUuid } = useParams()
  const navigate = useNavigate()

  const [searchParams] = useSearchParams()

  useEffect(() => {
    if (isFetching.current) return

    isFetching.current = true

    let clientTracking = ''
    const params: { [key: string]: string } = {}
    searchParams.forEach((value, key) => {
      key === 'clientTracking'
        ? (clientTracking = value)
        : (params[key] = value)
    })

    const hideInteractionContainer =
      searchParams.has('hideInteractionContainer') ?? false

    postWorkflow({
      workflowmodel_uuid: String(workflowModelUuid),
      clientTracking,
      dataContainerParams: params
    })
      .then((response: PostWorkflowResponse) => {
        if (response.success) {
          const workflowUuid = String(response.data.workflow.uuid)
          window.parent.postMessage(
            {
              workflowUuid
            },
            '*'
          )

          navigate(
            `/workflow/${workflowUuid}${hideInteractionContainer ? `?hideInteractionContainer=true` : ''}`,
            { replace: true }
          )
        }
      })
      .catch((error: ErrorMessage) => {
        console.log(error)
        navigate('/error', { replace: true })
      })
  }, [workflowModelUuid, navigate, searchParams])

  return (
    <>
      <div>
        <h1> ...... </h1>
      </div>
    </>
  )
}

export default WorkflowmodelRoutes
